import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const DroffLogo: React.FC = () => (
  <svg width="120" height="44" viewBox="0 0 120 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="18" r="3" fill="#ed1d39" />
    <rect x="2" y="13" width="18" height="3.5" rx="1.75" fill="#ed1d39" />
    <rect x="5" y="20" width="15" height="3.5" rx="1.75" fill="#ed1d39" />
    <text x="26" y="27" fontFamily="Arial Black, Arial, sans-serif" fontWeight="900" fontSize="20" fill="#000000" letterSpacing="-0.5">Droff</text>
    <text x="27" y="38" fontFamily="Arial, sans-serif" fontWeight="400" fontSize="8" fill="#000000" letterSpacing="3">LOGISTICS</text>
  </svg>
);

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  const navLinks = [
    { label: 'Home', to: '/' },
    { label: 'About', to: '/about' },
    { label: 'Services', to: '/services' },
    { label: 'Contact', to: '/contact' },
  ];

  return (
    <header className={`navbar${scrolled ? ' navbar--scrolled' : ''}`}>
      <div className="container navbar__inner">
        <Link to="/" className="navbar__logo">
          <DroffLogo />
        </Link>

        <nav className={`navbar__links${menuOpen ? ' navbar__links--open' : ''}`}>
          {navLinks.map(({ label, to }) => (
            <Link
              key={to}
              to={to}
              className={`navbar__link${location.pathname === to ? ' navbar__link--active' : ''}`}
            >
              {label}
            </Link>
          ))}
          <Link to="/contact" className="btn-primary navbar__cta">Get Started</Link>
        </nav>

        <button
          className={`navbar__burger${menuOpen ? ' navbar__burger--open' : ''}`}
          onClick={() => setMenuOpen(v => !v)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>
    </header>
  );
};

export default Navbar;
